import * as angular from "angular";
import {IController} from "angular";
import {PatchOmsOrderRequest} from "../../models/patch-oms-order-request.model";

export class OmsOrdersBulkEditComponent implements IController {

  ordersCount: number;
  payload: PatchOmsOrderRequest;
  sections: any;
  isHideLinesSection: boolean;
  onSectionsChange: Function;
  onPayloadChange: Function;

  constructor() {
  }

  $onInit() {
  }

  onToggleSection(section) {
    this.sections[section] = !this.sections[section];
    this.onSectionsChange({sections: this.sections})
  }

  onProgramTypesChange(programIds: string[]) {
    this.payload.programTypes = programIds;
    this.onPayloadChange(this.payload);
  }

  onFulfillmentLineTypesChange(lineTypes: string[]) {
    this.payload.lineTypes = lineTypes;
    this.onPayloadChange(this.payload);
  }

  onAccountSelect(id: string) {
    this.payload.accountId = id;
    this.onPayloadChange(this.payload);
  }

  onReferenceIdsChange(items: string[]) {
    this.payload.referenceIds = items;
    this.onPayloadChange(this.payload);
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsOrdersBulkEdit', {
    bindings: {
      ordersCount: '<',
      isHideLinesSection: '<',
      sections: '<',
      payload: '<',
      onSectionsChange: '&',
      onPayloadChange: '&'
    },
    template: require('./oms-orders-bulk-edit.html').default,
    controller: OmsOrdersBulkEditComponent
  });
